import React from 'react'
import PaymentReconciliationForm from '../../../features/Financial/PaymentReconciliationForm'

const PaymentReconciliation = () => {
  return (<PaymentReconciliationForm />
  )
}

export default PaymentReconciliation;